
import React from "react";

const CancelButton = ({
    title,
    onClick,
    bg,
    width="w-[250px]",
    border="border-green",
    height="h-[64px]",
    disabled= false,
    rounded="2xl"
}) => {
    return(
        <button 
        onClick={onClick}
        disabled={disabled}
        className={`${width} ${bg} flex items-center justify-center border-[2px]  font-itcdemi text-[18px] rounded-${rounded} py-[11px] px-[5px] 
            ${height} 
            ${disabled ? ' cursor-not-allowed text-gray border-gray' : `cursor-pointer text-green  ${border}`}
        `}
        >
            Cancelar

        </button>

    );
};

export default CancelButton;